import { render } from "./IndexView.vue?vue&type=template&id=69ca769e"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=69ca769e&lang=css"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__